import { render } from "./TermsAcknowledgement.vue?vue&type=template&id=272ca4a4"
import script from "./TermsAcknowledgement.vue?vue&type=script&lang=js"
export * from "./TermsAcknowledgement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__